export function openGoogleTranslateLink(
  fromLanguageCode: string,
  toLanguageCode: string,
  text: string,
): void {
  const gtLink = new URL('https://translate.google.com/');
  gtLink.searchParams.append('sl', fromLanguageCode.toLowerCase());
  gtLink.searchParams.append('tl', toLanguageCode.toLowerCase());
  gtLink.searchParams.append('text', text.trim());
  gtLink.searchParams.append('op', 'translate');

  window.open(gtLink.toString(), '_blank');
}
